/**
 * Cach tinh do vuong:
 * 1. xet do vuong can lo
 * 2. xet do vuong can tang
 * 3. tinh can hu phu: can tang, lo co dv < 18
 * 4. xet do vuong theo thang - vong truong sinh
 *    o nguyen cuc thi lay theo chi tru thang. khi vao dai van/luu nien thi phai bien doi theo chi dai van/luu nien
 *    vd tinh do vuong cua cac ban khi 3 can tang o dat Thai: 20.4 * 17/36 = 9.63
 * 5. xet do vuong theo vi tri, gan tuong tac manh, xa tuong tac yeu
 *    luc tuong tac nang lượng:
 *    CT: F = k * (F1 * F2) / (R * R) (tương tác giữa 2 can: k = 1/36)
 *    can lộ/trụ năm | trụ tháng | trụ ngày | trụ giờ
 *    can bản khí    | can bk    | can bk   | can bk
 *    can trung khí  | can tk    | can tk   | can tk
 *    can dư khí     | can dk    | can dk   | can dk
 *    đơn vị tương tác tính theo bình phương khoảng cách
 *    - cùng hàng liền trụ, cùng trụ liền hàng: 1
 *    - cùng hàng cách 1 trụ, cùng trụ cách 1 hàng: 4 (2b)
 *    - cùng hàng cách 2 trụ, cùng trụ cách 2 hàng: 9 (3b)
 *    - can lộ trụ năm và can bk tháng: 2 (1b + 1b)
 *    - can lộ trụ năm và can bk ngày: 5 (1b + 2b)
 *    - can lộ trụ năm và can bk giờ: 10 (1b + 3b)
 *    - can lộ trụ năm và can tk ngày: 8 (2b + 2b)
 *    - can lộ trụ năm và can tk giờ: 13 (2b + 3b)
 *    - can lộ trụ năm và can dk giờ: 18 (3b + 3b)
 * 6. xét độ vượng theo sinh phù khắc chế
 *    - trợ giúp cùng tính âm dương:  +1/2 (tăng tỉ lệ với lực tương tác)
 *    - trợ giúp khác tính âm dương:  +5/12
 *    - được sinh cùng tính âm dương: +5/12
 *    - được sinh khác tính âm dương: +1/3
 *    - bị khắc cùng tính âm dương:   -5/12
 *    - bị khắc khác tính âm dương:   -1/3
 *    - sinh xuất cùng tính âm dương: -1/12
 *    - sinh xuất khác tính âm dương: -2.5/36
 *    - khắc xuất cùng tính âm dương: -1/6
 *    - khắc xuất khác tính âm dương: -5/36
 */
import { getRoundDecimal, sinhKhac } from './tutru'

export const DV_AM_DUONG = 180
export const DV_CAN_LO = 36
export const DV_DIA_CHI = 30
export const DV_HOA_GIAP = 6

// export const CAN_TANG_CHI = [null, [10], [6, 10, 8], [1, 3, 5], [2], [5, 2, 10], [3, 5, 7], [4, 6], [6, 4, 2], [7, 9, 5], [8], [5, 8, 4], [9, 1]]
export const DV_CAN_TANG_CHI = [null, [30], [17, 12, 1], [17, 12, 1], [30], [17, 12, 1], [17, 12, 1], [29, 1], [17, 12, 1], [17, 12, 1], [30], [17, 12, 1], [18, 12]]

// export const VONG_TRUONG_SINH = [null, 'Trường Sinh', 'Mộc Dục', 'Quan Đới', 'Lâm Quan', 'Đế Vượng', 'Suy', 'Bệnh', 'Tử', 'Mộ', 'Tuyệt', 'Thai', 'Dưỡng']
// export const DV_BAC_VONG_TRUONG_SINH = [null, 8, 9, 10, 11, 12, 5, 4, 3, 2, 1, 6, 7]
export const DV_VONG_TRUONG_SINH = [null, 25.6, 28.2, 30.8, 33.4, 36, 17.8, 15.2, 12.6, 10, 7.4, 20.4, 23] // 18

/**
 * 1. Bac 1-5 trong vong TS
 * 2. ko duoc cac ban khi khac sinh phu
 * 3. qua suy nhuoc do bi khac che, hoac sinh xuat
 */
export const DV_CAN_HU_PHU = 17.8

/**
 * vd: can giap lo tru ngay co do vuong: 10
 * can nham lo tru nam co do vuong: 23
 * khoang cach: 2dv
 * luctuongtac: 10 * 23 / 36 / 4 = 1.6
 * can giap sinh cung tinh am duong: 10 + (1.6 * 1/2) = 10.8
 * can nham sinh xuat cung tinh am duong: 23 + (1.6 * -1/12) = 22.87
 */
export const tinhDoVuongTheoKhoangCach = (canA, canB, khoangcach = 1) => {
  const { dovuong: dovuongA, thienCan: thienCanA } = canA
  const { dovuong: dovuongB, thienCan: thienCanB } = canB
  const { amDuong: amDuongA, nguHanhID: hanhA } = thienCanA
  const { amDuong: amDuongB, nguHanhID: hanhB } = thienCanB

  const luctuongtac = dovuongA * dovuongB / 36 / Math.exp(khoangcach)

  const cungAmduong = amDuongA === amDuongB
  let tile

  const sinhkhac = sinhKhac(hanhA, hanhB)
  if (sinhkhac === 1) { // sinh xuat
    tile = cungAmduong ? -1 / 12 : -2.5 / 36
  } else if (sinhkhac === -1) { // khac xuat
    tile = cungAmduong ? -1 / 6 : -1 / 36
  } else if (sinhkhac === -2) { // bi khac
    tile = cungAmduong ? -5 / 12 : -1 / 3
  } else if (sinhkhac === 2) { // duoc sinh
    tile = cungAmduong ? 5 / 12 : 1 / 3
  } else { // tro giup
    tile = cungAmduong ? 1 / 2 : 5 / 12
  }
  const tileA = tile
  const tileB = sinhkhac > 0 ? 3 - sinhkhac : 3 + sinhkhac
  return [
    getRoundDecimal(luctuongtac * tileA + dovuongA),
    getRoundDecimal(luctuongtac * tileB + dovuongB)
  ]
}
